/**
 * Функция для вычисления процента от числа.
 *
 * @param {number} part Часть от целого числа, которую нужно вычислить в процентах.
 * @param {number} total Целое число, от которого вычисляется процент.
 * @returns {number} Возвращает процентное соотношение от целого числа, округленное до целого числа. Если total равно 0, возвращает 0.
 *
 * @example
 * calculatePercent(50, 200) // вернёт 25
 * calculatePercent(0, 0)    // вернёт 0
 */
export const calculatePercent = (part, total) =>
  total !== 0 ? Math.floor((part / total) * 100) : 0;
